const slidersByCourse = (
  state = {
    isFetchingSliders: false,
    isFetchingDefaultSlider: false,
    isFetchingDefaultSliderError: false,
    defaultSlider: null,
    selectedSlide: null,
    receivedAt: null,
    data: []
  },
  action
) => {
  switch (action.type) {
    case 'REQUEST_SLIDERS':
      return {
        ...state,
        isFetchingSliders: true
      };
    case 'RECEIVE_SLIDERS':
      return {
        ...state,
        isFetchingSliders: false,
        receivedAt: Date.now(),
        data: action.sliders
      };
    case 'REQUEST_DEFAULT_SLIDER':
      return {
        ...state,
        isFetchingDefaultSlider: true
      };
    case 'REQUEST_DEFAULT_SLIDER_ERROR':
      return {
        ...state,
        isFetchingDefaultSlider: false,
        isFetchingDefaultSliderError: true
      };
    case 'RECEIVE_DEFAULT_SLIDER':
      const slider = state.data.find(slider => {
        return slider.id === action.sliderId;
      });

      return {
        ...state,
        isFetchingDefaultSlider: false,
        defaultSlider: action.sliderId,
        selectedSlide:
          slider && slider.defaultSlide ? slider.defaultSlide : null
      };
    case 'SELECT_SLIDE':
      return {
        ...state,
        selectedSlide: action.slideId
      };
    case 'SELECT_DEFAULT_SLIDE': {
      const slider = state.data.find(slider => {
        return slider.id === state.defaultSlider;
      });

      return {
        ...state,
        selectedSlide:
          slider && slider.defaultSlide ? slider.defaultSlide : null
      };
    }
    default:
      return state;
  }
};

const sliders = (state = {}, action) => {
  switch (action.type) {
    case 'RECEIVE_COURSES':
      return {
        ...state,
        ...action.courses.reduce((accumulator, currentCourse) => {
          return {
            ...accumulator,
            [currentCourse.courseCode]: slidersByCourse(
              state[currentCourse.courseCode],
              action
            )
          };
        }, {})
      };
    case 'REQUEST_DEFAULT_SLIDER':
    case 'REQUEST_DEFAULT_SLIDER_ERROR':
    case 'REQUEST_SLIDERS':
    case 'RECEIVE_DEFAULT_SLIDER':
    case 'RECEIVE_SLIDERS':
    case 'SELECT_SLIDE':
    case 'SELECT_DEFAULT_SLIDE':
      return {
        ...state,
        [action.courseId]: slidersByCourse(state[action.courseId], action)
      };
    default:
      return state;
  }
};

export default sliders;
